module.exports = __webpack_public_path__ + "media/26.084ec0c4.mp3";